import { Box } from "@mui/system";
import { Editor } from "@tinymce/tinymce-react";
import { useSelector } from "react-redux";
import { Alert, Button, Skeleton } from "@mui/material";
import useEditorInitialization from "./use-editor-initialization";
import { editorPlugins, editorToolbar, setupEditor } from "./editor-config";

const TextEditor = ({ value, change, hint = "", readOnly = false }) => {
  const { themeColor } = useSelector((state) => state.themeColor);
  const useDarkMode = themeColor === "dark";
  const initialization = useEditorInitialization();
  return (
    <Box sx={{ direction: "ltr !important" }}>
      {initialization.status === "waiting" && <Skeleton variant="rectangular" height={600} aria-label="آماده‌سازی ویرایشگر" />}
      {initialization.status === "failed" && <Alert severity="error" action={<Button onClick={initialization.retry}>تلاش مجدد</Button>}>ویرایشگر آماده نشد؛ متن شما حفظ شده است.</Alert>}
      {["starting", "ready"].includes(initialization.status) &&
      <Editor
        key={initialization.attempt}
        onInit={initialization.initialized}
        onScriptsLoadError={initialization.failed}
        tinymceScriptSrc="/js/tinymce/tinymce.min.js"
        onEditorChange={change}
        value={value ?? ""}
        disabled={readOnly}
        init={{
          plugins: editorPlugins,
          setup: setupEditor,
          imagetools_cors_hosts: ["picsum.photos"],
          menubar: "file edit view insert format tools table help",
          toolbar: editorToolbar,
          toolbar_sticky: true,
          autosave_ask_before_unload: true,
          directionality :"rtl",
          autosave_interval: "30s",
          autosave_prefix: "{path}{query}-{id}-",
          autosave_restore_when_empty: false,
          autosave_retention: "2m",
          image_advtab: true,
      
          link_list: [
            { title: "My page 1", value: "https://www.tiny.cloud" },
            { title: "My page 2", value: "http://www.moxiecode.com" },
          ],
          image_list: [
            { title: "My page 1", value: "https://www.tiny.cloud" },
            { title: "My page 2", value: "http://www.moxiecode.com" },
          ],
          image_class_list: [
            { title: "None", value: "" },
            { title: "Some class", value: "class-name" },
          ],
          importcss_append: true,
          file_picker_callback: function (callback, value, meta) {
            /* Provide file and text for the link dialog */
            if (meta.filetype === "file") {
              callback("https://www.google.com/logos/google.jpg", {
                text: "My text",
              });
            }

            /* Provide image and alt text for the image dialog */
            if (meta.filetype === "image") {
              callback("https://www.google.com/logos/google.jpg", {
                alt: "My alt text",
              });
            }

            /* Provide alternative source and posted for the media dialog */
            if (meta.filetype === "media") {
              callback("movie.mp4", {
                source2: "alt.ogg",
                poster: "https://www.google.com/logos/google.jpg",
              });
            }
          },
          templates: [
            {
              title: "New Table",
              description: "creates a new table",
              content:
                '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>',
            },
            {
              title: "Starting my story",
              description: "A cure for writers block",
              content: "Once upon a time...",
            },
            {
              title: "New list with dates",
              description: "New List with dates",
              content:
                '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>',
            },
          ],
          template_cdate_format: "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
          template_mdate_format: "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
          height: 600,
          image_caption: true,
          quickbars_selection_toolbar:
            "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
          noneditable_noneditable_class: "mceNonEditable",
          toolbar_mode: "sliding",
          contextmenu: "link image imagetools table",
          skin: useDarkMode ? "oxide-dark" : "oxide",
          content_css: useDarkMode ? "dark" : "default",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
      />}
    </Box>
  );
};

export default TextEditor;
